/**
 * Логика водоснабжения: что на конце трубы и куда её можно подвести.
 *
 * Разводка не хранится отдельно — она и есть трубы. Точка «подключена», если к ней
 * подходит хоть одна труба; какую среду точка принимает, знает каталог (`acceptsMedium`):
 * к стояку ХВС горячую трубу не подвести, к парной водорозетке подходят обе.
 */
import type { ItemsLayer } from "@/shared/plan";
import type { CatalogItem, WaterMedium } from "@/shared/catalog";
import { acceptsMedium, getCatalogItem, isWaterPoint } from "@/shared/catalog";

export { useDrawPipe } from "./hooks/useDrawPipe";

/** Тип из каталога для конца трубы — точки водоснабжения на стене. */
export const pipeEndCatalogItem = (plumbing: ItemsLayer, id: string): CatalogItem | null => {
	const ref = plumbing.fixtures[id]?.ref;
	return ref ? getCatalogItem(ref) : null;
};

/** Можно ли начать или закончить трубу этой среды на объекте с таким id. */
export const canConnectPipe = (plumbing: ItemsLayer, id: string, medium: WaterMedium): boolean => {
	const item = pipeEndCatalogItem(plumbing, id);
	return isWaterPoint(item) && acceptsMedium(item, medium);
};
